<template>
    <el-dialog
      :title="propTitle"
      :visible.sync="dialogIsShow"
      width="750px" 
      append-to-body
    >
      <el-table
        :data="jobList"
        v-loading="listLoading"
        stripe
        border
        :header-cell-style="{ background: '#F5F7FA' }"
      >
        <el-table-column property="Id" label="Id" width="80">
          <template slot-scope="scope">
            <!-- <span>{{ scope.row.JobNo || "--" }}</span> -->
            <router-link
              style="color: black"
              :to="{ path: '/job/b2bJobInfo', query: { JobId: scope.row.Id } }"
              target="_blank">{{ scope.row.Id || "--" }}</router-link>
          </template>
        </el-table-column> 

        <el-table-column property="JobNo" label="工单编号" width="120">
          <template slot-scope="scope">
            <router-link
              style="color: black"
              :to="{ path: '/job/b2bJobInfo', query: { JobId: scope.row.Id } }"
              target="_blank"
              >{{ scope.row.JobNo || "--" }}</router-link
            >
          </template>
        </el-table-column>
  
        <el-table-column
          property="Title"
          label="标题"
          show-overflow-tooltip >
          <template slot-scope="scope">
            <span>{{ scope.row.Title || "--" }}</span>
          </template>
        </el-table-column>  
  
        <el-table-column property="IsProjectJob" label="工单类别" width="120">
          <template slot-scope="scope">
            <span>{{(scope.row.IsProjectJob == 1? "项目": "标准") }}</span>
          </template>
        </el-table-column>
  
       <el-table-column property="PropCount" label="道具数量" width="90">
        </el-table-column>  
        <el-table-column property="PropAmount" label="道具费" width="90">
        <template slot-scope="scope">
            <span>￥{{scope.row.PropAmount }}</span>
          </template>
        </el-table-column>  
      </el-table>
      <div style=" margin-top: 10px; overflow:hidden">
        <div style="float: left;" v-show="jobList.length">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[10, 20, 50, 100, 200]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="listCount">
          </el-pagination>
        </div>
      </div>
    </el-dialog>
  </template> 
  
  <script>
  import {
    getPropAmountJobList, // 添加统计
  } from "@/service/jobStatistics";
  export default { 
    data() {
      return {
        dialogIsShow: false,
        listLoading: false,
  
        propType:0,
        startTime:"",
        endTime:"", 
        jobList: [],
        listCount: 0,
        pageNum: 1,
        pageSize: 10,
      };
    },
    computed: {
      propTitle(){
        var title="";
        if(this.propType==1)
        {
          title="急单道具工单列表";
        }
        else if(this.propType==2)
        {
          title="1天置顶道具工单列表";
        }
        else if(this.propType==3)
        {
          title="3天置顶道具工单列表";
        }
        else if(this.propType==4)
        {
          title="延时道具工单列表";
        }
        else if(this.propType==5)
        {
          title="一键推送道具工单列表";
        }
        return title;
      }
    },
    methods: {
      openDia(startTime,endTime,propType) {
        this.propType=propType;
        this.startTime=startTime;
        this.endTime=endTime; 
        this.pageNum = 1;
        this.dialogIsShow = true;
        this.loadList();
      },
  
      handleSizeChange(val) {
        if (this.listLoading) return;
        this.pageNum = 1;
        this.pageSize = val;
        this.loadList();
      },
      handleCurrentChange(val) {
        if (this.listLoading) return;
        console.log(val);
        this.pageNum = val;
        this.loadList();
      },
  
      async loadList() {
        this.listLoading = true;
  
        var data = {
          StartDate:this.startTime,
          EndDate:this.endTime, 
          PropType:this.propType,
          PageNum: this.pageNum,
          PageSize: this.pageSize, 
          platform: "pcweb",
        };
  
        console.log(data);
  
        let res = await getPropAmountJobList(data);
        this.listLoading = false;
        if (res.Result != 1) {
          return this.$message.error("获取失败请联系开发人员");
        }
        console.log(res);
        if (res.Result != 1) {
          return this.$message.error(res.Message);
        }
        //this.$message({ message: res.Message, type: "success" });
  
        this.$nextTick(() => {
          this.listCount = res.Data.TotalCount;
          this.jobList = res.Data.JobList;
          console.log("listCount:" + this.listCount);
          console.log(this.jobList);
        });
      },
    },
  };
  </script>
      
  <style scoped>
  .gradHeader {
    background: red !important;
  }
  </style>